export default class WeatherWidget {
  elements;
  icons = {
    temprature: sw.theme_uri + '/assets/images/temprature.svg'
  }

  constructor(selector) {
    this.elements = Array.from(document.querySelectorAll(selector));
    if (this.elements) {
      this.show();
    }
  }

  show() {
    if (this.elements) {
      this.getWeather().then(weather => {
        this.elements.forEach(element => {
          const isMini = element.dataset.type === 'mini';
       
          if (isMini) {
            element.innerHTML = `<img class="icon" width="40" height="40" src="https://openweathermap.org/img/wn/${weather.icon}@2x.png" alt="${weather.atmosphere}">
              <span class="text"><span class="temprature">${weather.temprature} °C</span> <span class="ml-3">${weather.name}</span></span>`;
            return;
          } else {
            this.getForecast().then(forecast => {
              const currentDate = new Date().toLocaleDateString('el-GR', { weekday: 'short', month: 'short', day: 'numeric' });
              let template = `
              <div class="d-flex justify-content-between align-items-baseline border-bottom border-3 border-black text-uppercase">
                <span class="large font-weight-bold mr-3">${weather.name}</span>
                <span class="smaller">${currentDate}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center border-bottom border-grey mb-3">
                <figure class="d-flex align-items-center mb-0 mr-2">
                  <img class="icon mb-0" width="60" height="60" src="https://openweathermap.org/img/wn/${weather.icon}@2x.png" alt="${weather.atmosphere}">
                  <span class="smaller text-uppercase">${weather.atmosphere}</span>
                </figure>
                <figure class="d-flex align-items-center mb-0">
                  <img class="icon mb-0 mr-2" width="25" height="25" src="${this.icons.temprature}" alt="${weather.atmosphere}">
                  <span class="display-4 font-weight-normal temprature text-nowrap">${weather.temprature}°C</span>
                </figure>
              </div>`;
              template += '<div class="forecast d-flex justify-content-around">'
              forecast.forEach((day, index) => {
                if (index > 2) {
                  return;
                }
                let date = new Date(day.date * 1000).toLocaleDateString('el-GR', { weekday: 'long' });
                template += `
                <div class="text-center">
                  <span class="smaller text-uppercase">${date}</span>
                  <figure class="mb-0">
                    <img class="icon mb-0" width="60" height="60" src="https://openweathermap.org/img/wn/${day.icon}@2x.png" alt="${day.atmosphere}">
                  </figure>
                  <p class="mb-0">
                    <span class="font-weight-normal temprature">${day.temprature.max}°C</span>
                  </p>
                  <p class="mb-0">
                    <span class="font-weight-normal temprature">${day.temprature.min}°C</span>
                  </p>
                </div>`;
              });
              template += '</div>';
              element.innerHTML = template;
            })
          }
        });
      });
    }
  }

  getWeather() {
    return fetch(sw.weather.now, {
      headers: {
        'X-WP-Nonce': sw.nonce
      }
    }).then(response => {
      return response.json();
    }).then((weatherData) => {
      return {
        name: weatherData.name,
        temprature: parseInt(weatherData.main.temp, 10),
        atmosphere: weatherData.weather[0].description,
        icon: weatherData.weather[0].icon,
      };
    });
  }

  getForecast() {
    return fetch(sw.weather.forecast, {
      headers: {
        'X-WP-Nonce': sw.nonce
      }
    }).then(response => {
      return response.json();
    }).then((forecastData) => {
      return forecastData.list.map(forecast => {
        return {
          name: forecastData.city.name,
          date: forecast.dt,
          temprature: {
            max: parseInt(forecast.temp.max, 10),
            min: parseInt(forecast.temp.min, 10),
          },
          atmosphere: forecast.weather[0].description,
          icon: forecast.weather[0].icon,
        }
      });
    });
  }
}
